import { EDITOR_VIEW_NAME } from "../core/constants";
import { getViewData, setViewData } from "../core/views";
import { executeLLMEvalTask } from "./chatrequests";
import { isWaitingForSuccessEvent } from "./evaluate";
import { requestFinish } from "./globals";

export const evaluateChat = async (project, progress, messages) => {
  if (project.eval !== undefined) {
    // Direkte Evaluierung des Gesamtprojekts
    return await verifyTaskCompletion(messages, project.eval);    
  }

  if (project.subTasks !== undefined) {    
    const currentSubTaskIndex = progress === undefined ? 0 : progress;
    const subTask = project.subTasks[currentSubTaskIndex];
    if (subTask !== undefined) {
      // Verwenden von verifyTaskCompletion für die Evaluierung der SubTask
      return await verifyTaskCompletion(messages, subTask);
    }
  }

  return false;
}  

const runNextEvaluation = async (project, projectProgress:number, messages) => {
  
  let nextProgress = projectProgress;
  let nextFinished = true;
  while(nextFinished === true && nextProgress < project.subTasks.length) {
    
    nextFinished = await verifyTaskCompletion(messages, project.subTasks[nextProgress].eval);  
    if (nextFinished) {
      nextProgress++;
    }
  }
  return nextProgress;
}

const verifyTaskCompletion = async (messages, subTask) => {
  if (!subTask.eval) {
    return false;
  }
  switch (subTask.eval.type) {
    case "CHECK_MESSAGE":
      // Überprüfe, ob mindestens eine Nachricht alle erforderlichen IDs enthält
      const checkMessageSuccess = messages.some(message =>
        subTask.eval.ids.every(id => message.msg?.toLowerCase().includes(id.toLowerCase()))
      );
      if (!checkMessageSuccess) {
        console.log(`Aufgabe ${subTask.number} nicht erfüllt: ${subTask.error}`);
      }
      return checkMessageSuccess;

    case "COUNT_MESSAGES":
      // Überprüfe, ob die Gesamtzahl der Nachrichten den Mindestwert erreicht
      const countMessagesSuccess = messages.length - 1 >= subTask.eval.minCount;
      if (!countMessagesSuccess) {
        console.log(`Aufgabe ${subTask.number} nicht erfüllt: ${subTask.error}`);
      }
      return countMessagesSuccess;
    case "LLM_EVAL":
        // Führe die LLM-Evaluierung durch
        const evalResult = await executeLLMEvalTask(subTask.desc, messages);
        console.log(`LLM-EVAL Ergebnis: ${JSON.stringify(evalResult)}`);
        return evalResult.result.success;

    default:
      console.log(`Unbekannter Überprüfungstyp für Aufgabe ${subTask.number}`);
      return false;
  }
};

export const runChatPostEvaluation = async (messages) => {
  setTimeout(async () => {
    const editorState = getViewData(EDITOR_VIEW_NAME);
    const newState2 = { ...editorState };        

    const finished = await evaluateChat(newState2.project, newState2.data.projectProgress, messages);
    const waitForSuccessEvent = isWaitingForSuccessEvent(newState2.project, newState2.data.projectProgress);
    const gotErrors = editorState.data.errors && editorState.data.errors.length > 0;
    let projectProgress = newState2.data.projectProgress;
    let projectError = newState2.data.projectError;
    let errorCounter = newState2.data.errorCounter;
    
    if (finished && !gotErrors && newState2.project.eval) {
      requestFinish();
    } else if (newState2.project.subTasks) {
      if (finished && !gotErrors) {
        projectError = undefined
        errorCounter = undefined;
        if (projectProgress === undefined) {
          projectProgress = 1;
          projectProgress = await runNextEvaluation(newState2.project, projectProgress, messages)
        } else {
          projectProgress++;
          projectProgress = await runNextEvaluation(newState2.project, projectProgress, messages)
        }
        if (projectProgress >= newState2.project.subTasks.length) {
          requestFinish();
        }
      } else {
        projectError = projectProgress === undefined ? 1 : projectProgress + 1;
        errorCounter = errorCounter === undefined ? 1 : errorCounter + 1;
      }
    }

    newState2.data = {
      ...editorState.data,
      projectProgress,
      projectError,
      errorCounter,
      executionRequested : false,
      waitForSuccessEvent : waitForSuccessEvent ? true : undefined
    };
    
    console.log("runChatPostEvaluation saving:", newState2);
    setViewData(EDITOR_VIEW_NAME, newState2);    
    /*if (!errorCounter) {
      logGamificationEvent("ProjectExecuted", "Projekt ausgeführt", "Projekt wurde erfolgreich ausgeführt");
    } else {
      logGamificationEvent("ErrorOccured", "Fehler aufgetreten", "Fehler beim Ausführen des Projekts");
    } */ 
  }, 1500);
}